export interface IChangeCategoryBoxesOrder {
    order: {
        [id: string]: string,
    };
}
